import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const RolesKey = 'roles'
const TopNavKey = 'TopNavs'
const AllRoles = 'allRoles'
const defaultCurKey = 'defaultCur'
const TopdefaultCur = 'TopdefaultCur'
const PermissionKey = 'permission'
const AllPermissionKey = 'allPermission'
const roleIdKey = 'roleId'
const routerArrKey = 'routerArr'
const nickname = 'nickname'
const avatar = 'avatar'
const defaultPage = 'defaultPage'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRoles() {
  return Cookies.get(RolesKey)
}

export function setRoles(roles) {
  return Cookies.set(RolesKey, roles)
}

export function removeRoles() {
  return Cookies.remove(RolesKey)
}

export function setTopNavs(topNavs) {
  return Cookies.set(TopNavKey, topNavs)
}

export function getTopNavs() {
  return Cookies.get(TopNavKey)
}

export function removeTopNavs() {
  return Cookies.remove(TopNavKey)
}

export function setAllRoles(roles) {
  return Cookies.set(AllRoles, roles)
}

export function getAllRoles() {
  return Cookies.get(AllRoles)
}

export function removeAllRoles() {
  return Cookies.remove(AllRoles)
}

export function setDefaultCur(index) {
  return Cookies.set(defaultCurKey, index)
}

export function getDefaultCur() {
  return Cookies.get(defaultCurKey)
}

export function setTopdefaultCur(index) {
  return Cookies.set(TopdefaultCur, index)
}

export function getTopdefaultCur() {
  return Cookies.get(TopdefaultCur)
}

export function getPermission() {
  return JSON.parse(localStorage.getItem(PermissionKey))
}

export function setPermission(data) {
  return localStorage.setItem(PermissionKey, JSON.stringify(data))
}

export function removePermission() {
  return localStorage.removeItem(PermissionKey)
}

export function getAllPermission() {
  return JSON.parse(localStorage.getItem(AllPermissionKey))
}

export function setAllPermission(data) {
  return localStorage.setItem(AllPermissionKey, JSON.stringify(data))
}

export function removeAllPermission() {
  return localStorage.removeItem(AllPermissionKey)
}

/** 角色ID 是否为管理员 */
export function setRoleId(id) {
  return Cookies.set(roleIdKey, id)
}
export function getRoleId() {
  return Cookies.get(roleIdKey)
}
export function removeRoleId() {
  return Cookies.remove(roleIdKey)
}

/** 昵称 */
export function setNickname(name) {
  return Cookies.set(nickname, name)
}
export function getNickname() {
  return Cookies.get(nickname)
}
export function removeNickname() {
  return Cookies.remove(nickname)
}
/** 头像 */
export function setAvatar(data) {
  return Cookies.set(avatar, data)
}
export function getAvatar() {
  return Cookies.get(avatar)
}
export function removeAvatar() {
  return Cookies.remove(avatar)
}
/** 默认打开页面 */
export function setDefaultPage(data) {
  return localStorage.setItem(defaultPage, JSON.stringify(data))
}
export function getDefaultPage() {
  return JSON.parse(localStorage.getItem(defaultPage))
}
export function removeDefaultPage() {
  return localStorage.removeItem(defaultPage)
}

export function setRouterArr(data) {
  return localStorage.setItem(routerArrKey, JSON.stringify(data))
}
export function getRouterArr() {
  return JSON.parse(localStorage.getItem(routerArrKey))
}
export function removeRouterArr() {
  return localStorage.removeItem(routerArrKey)
}

export function removeAllCookie() {
  var cookies = document.cookie.split(';')
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i]
    var eqPos = cookie.indexOf('=')
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}

/** 查看是否为数组且长度>0 */
export function checkArr(array) {
  if (array && array instanceof Array && array.length > 0) {
    return true
  } else {
    return false
  }
}
